import { config } from '../../Config';

const AddPublication = async (chatId, userId, category, subcategory, description, tags) => {
    const url = config.addPublication;
    const payload = {
        chatId,
        userId,
        category,
        subcategory,
        description,
        tags,
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Failed to add publication: ${errorData.message || response.statusText}`);
        }

        const data = await response.json();
        // console.log('Publication added successfully:', data);
        return { success: true, data };
    } catch (error) {
        // console.error('Error adding publication:', error);
        return { success: false, error: error.message };
    }
};

export default AddPublication;
